import React from 'react';
import { useTypedSelector } from '../../../../../hooks';
import { getAppliedDiscount } from '../../../ducks';
import { DiscountSummary } from '../../DiscountSummary';

export const TermsBlockDiscount = (): JSX.Element | null => {
  const discount = useTypedSelector(getAppliedDiscount);

  if (!discount) {
    return null;
  }

  return (
    <div className={'pt-[1em]'}>
      <DiscountSummary discount={discount} variant={'terms'} />
    </div>
  );
};
